import type { ReactElement } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LoyaltyEsimDetailsModal from 'loyalty/components/LoyaltyEsimDetailsModal'
import {
  formatLoyaltyEsimInternationalDataHeading,
  getLoyaltyEsimGbAmount,
} from 'loyalty/utils/loyaltyBenefitLabels'

interface Props {
  layout: 'tile' | 'row'
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyEsimPackage(props: Props) {
  const { layout, benefit, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()

  const heading = formatLoyaltyEsimInternationalDataHeading(
    intl,
    getLoyaltyEsimGbAmount(benefit) ?? '-',
  )

  const handleDetailsClick = useCallback(() => {
    showModal(<LoyaltyEsimDetailsModal />)
  }, [showModal])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="esim_package"
    heading={heading}
    subtitle={benefitLabel}
    onClick={handleDetailsClick}
  />
}

export default LandingPageLoyaltyEsimPackage
